export default __webpack_public_path__ + "static/media/undraw_User_flow_re_bvfx.2cb12df0.svg";